<template>
  <b-card>
    <!-- Form -->
    <b-form class="p-2">
      <!-- <b-row>
          <b-col
            xl="6"
          >
            <b-form-group
              label="Nama FAQ"
              label-for="nama"
            >
              <b-form-input
                id="nama"
                v-model="rowData.data.nama"
                autofocus
                trim
                placeholder=""
              />
            </b-form-group>

          </b-col>
        </b-row> -->

      <b-row>
        <b-col xl="8">
          <b-form-group label="Kategori Sub Kategori Tiket" label-for="kategori">
            <v-select
              v-model="rowData.data.kategori_jenis_tiket"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="kategoriJenisTiketOptions"
              :reduce="val => val.value"
              :clearable="false"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col xl="8">
          <b-form-group label="Sub Kategori Tiket" label-for="keterampilan">
            <b-form-input id="nama" v-model="rowData.data.nama" autofocus trim placeholder="" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-checkbox id="flg_document" switch v-model="rowData.data.flg_document">
            File Document PDF
          </b-form-checkbox>
        </b-col>
      </b-row>
      <!-- <b-row>
          <b-col
            xl="6"
          >
            <b-form-group
              label="Deskripsi FAQ"
              label-for="nama"
            >
              <b-form-textarea
                id="deskripsi"
                v-model="rowData.data.deskripsi"
                autofocus
                trim
                placeholder=""
              />
            </b-form-group>

          </b-col>
        </b-row> -->
      <b-row>
        <b-col xl="8">
          <b-form-group label="Hak Akses" label-for="hak-akses">
            <span v-for="item in optionsLocal.roles" :key="item.id" md="5">
              <b-button
                v-if="item.active"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                class="mt-1 mr-1"
                @click="hapusRoles(item.id)"
              >
                <feather-icon icon="CheckIcon" />
                {{ item.name }}
              </b-button>
              <b-button
                v-else
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-secondary"
                class="mt-1 mr-1"
                @click="pilihRoles(item.id)"
              >
                {{ item.name }}
              </b-button>
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Form Actions -->
      <div class="d-flex mt-2">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mr-2"
          @click="updateData"
        >
          Simpan
        </b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard,
  BButton,
  BAvatar,
  BRow,
  BCol,
  BBadge,
  BForm,
  BFormGroup,
  BFormInvalidFeedback, // BFormTextarea,  BFormInput
  BFormSpinbutton,
  BFormInput,
  BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { required, alphaNum, email } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import { avatarText } from '@core/utils/filter'
import useList from '@/connection-api/jenistiket/list'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import storeModule from '@/connection-api/user/storeModule'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormCheckbox,
    // BFormTextarea,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      optionsLocal: {},
      required,
      alphaNum,
      email,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    kategoriJenisTiketOptions: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    if (this.rowData.data.flg_document === 1) {
      this.rowData.data.flg_document = true
    } else {
      this.rowData.data.flg_document = false
    }
    // this.userData = this.rowData.data
    // console.log(this.userData)
    this.reloadData()
  },
  setup() {
    const { resolveUserRoleVariant, resolveUserStatusVariant } = useList()
    const blankUserData = {
      // nama: this.rowData.data.nama,
      // wilayah: this.rowData.data.wilayah,
      // upt: this.rowData.data.upt,
      // jenis_asset_id: this.rowData.data.jenis_asset_id,
      // status_asset_id: this.rowData.data.status_asset_id,
      // tanggal_aktif: this.rowData.data.tanggal_aktif,
      // luas_tanah: this.rowData.data.luas_tanah,
      // luas_bangunan: this.rowData.data.luas_bangunan,
      // harga_perolehan: this.rowData.data.harga_perolehan,
      // id: this.rowdata.data.id,
    }
    // alert(this.userData.nama)
    const userData = ref(JSON.parse(JSON.stringify(blankUserData)))

    const onSubmit = () => {
      store
        .dispatch('keterampilan/updateData', this.rowData.data)
        .then(response => {})
        .catch(error => {
          // console.log
        })
    }

    const { refFormObserver, getValidationState, resetForm } = formValidation()

    return {
      avatarText,
      resolveUserRoleVariant,
      resolveUserStatusVariant,

      userData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
  methods: {
    reloadData() {
      const USER_APP_STORE_MODULE_NAME = 'pengguna'
      // Register module
      if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {
        store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)
      }
      store
        .dispatch('pengguna/fetchDataRolesJenisTiket', { id: this.$route.params.id })
        .then(response => {
          this.optionsLocal = response.data.data
          // console.log('302')
          // console.log(response.data.data.roles)
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.optionsLocal = {}
          }
        })
    },
    pilihRoles(guardName) {
      const localdata = {
        rules: guardName,
        id_jenis: this.$route.params.id,
      }
      store
        .dispatch('pengguna/addDataRolesJenisTiket', localdata)
        .then(response => {
          this.reloadData()
        })
        .catch(error => {
          if (error.response.status === 404) {
            // console
          }
        })
    },
    hapusRoles(guardName) {
      const localdata = {
        id_jenis: this.$route.params.id,
        rules: guardName,
      }
      store
        .dispatch('pengguna/removeDataRolesJenisTiket', localdata)
        .then(response => {
          this.reloadData()
        })
        .catch(error => {
          if (error.response.status === 404) {
            // console
          }
        })
    },
    async updateData() {
      // console.log(this.rowData.data)
      store
        .dispatch('keterampilan/updateData', this.rowData.data)
        .then(response => {
          this.makeToast('success', 'Simpan Data Berhasil Dilakukan')
          setTimeout(() => this.$router.push({ name: 'kelola-jenistiket' }), 2000)
        })
        .catch(error => {
          // console.log(error)
          let messageError = ''
          if (error.response.data.data === 'The nama field is required. ') {
            messageError = 'The Sub Kategori Tiket is required. '
          } else {
            messageError = error.response.data.data
          }
          // alert(error.response.data.data)
          this.makeToast('danger', messageError)
          this.show = false
        })
    },
    formatPrice(value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate(value, format) {
      return moment(String(value)).format(format)
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        // title: `Variant ${variant || 'default'}`,
        title: 'Keterampilan',
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
  },
}
</script>

<style></style>
